export default "__VITE_ASSET__c4e0423c__"